<template>
     <div id="Tariff" style="float: right;width:100%;height: 100%;direction:rtl">
        <div class="card" style="float: right;width:100%;height: 100%">
            <div class="card-header">
                <CRow>
                     <h3 class="card-title"  > <CIcon name="cil-map" style="width: 20px;height: 20px"/>&nbsp;&nbsp;
                        تقویم
                    </h3>
                </CRow>
               
                 <CRow>
                    <CCol>
                        <!-- <CSelect label="انتخاب خط" ref="fleetSelect"   :options="GetOtions($store.state.Fleets)" :value.sync="FleetID"   @change="changeFleet"    style="color: white" > </CSelect> -->
                    </CCol>
                    <CCol>
                        
                    </CCol>
                    <CCol>
                        
                    </CCol>
                    <CCol>
                        <CButton  @click="DialogAddOrEditDayShow()"   color="outline-primary" style="float:left;border-bottom-left-radius: 2px;border-top-left-radius: 2px;border-top-right-radius: 2px;border-bottom-right-radius: 2px" title="تعیین روز" >تعیین روز</CButton>&nbsp;
                    </CCol>
                    <!-- @change="indexPriority=$event.target.selectedIndex" -->

                </CRow>
            </div>
            <div class="card-body" style="float: right;width:100%;height: 100%;min-height: 450px;background:white;">
                    <persian-calendar
                    :events-list="events"
                    @on-day-click="addEvent"
                    @on-event-click="addEvent"
                    :display-period.sync="period"
            >
                <template slot="event" slot-scope="i">
                   <div
                        :key="i.value.id"
                        :class="i.value.classes"
                        :style="`top:${i.top};background-color:${i.value.color};`"
                        class="vpc_event" 
                        style="border:2px dashed #eee"
                >
                    <!--  Anything You Wish -->
                    <span class="vpc_event-title" style="text-decoration: underline">{{ i.value.title }}</span>
                </div>
                </template>
            </persian-calendar>
            </div>
        </div>
        <CModal
                title=""
                color="info"
                :closeOnBackdrop="false"
                :size="'l'"
                :show.sync="DialogAddOrEditDay"
        >
            <div style="direction: ltr;text-align: right">
                
                <CRow style="direction:rtl">
                    <CCol>
                        <div>
                            <label  style="color: white" for="stopTime">انتخاب روز:</label>
                            <date-picker v-model="toDate" aria-label="انتخاب روز" type="date"></date-picker>
                        </div>
                    </CCol>
                    <CCol>
                        <CSelect label="نوع روز"   :options="GetOtionsDay($store.state.DayDefine_GetAll.RequestResponse)" :value.sync="DayDefineID"      style="color: white" > </CSelect>
                        <!-- <CInput style="width:100%;max-width:300px;" type="number" v-model="txtTotalTime" label="زمان کلی"/> -->
                    </CCol>
                    
                </CRow>
                <CRow style="direction:rtl">
                    <CTextarea v-model="txtMessage" rows="4" label="پیام"/>
                </CRow>
                
                
        
                
            </div>
            <template #header>

                <h4 class="modal-title" style="direction: rtl"> <CIcon name="cil-sun" width="20px" height="20px"/>&nbsp;&nbsp; تعیین روز </h4>

            </template>
            <template #footer>
                <CButton @click="DialogAddOrEditDay = false" color="danger">انصراف</CButton>
                <CButton @click="Calendar_InsertAndUpdate()" color="primary">&nbsp;&nbsp;ذخیره</CButton>
            </template>
            
        </CModal>
    </div>
</template>
<script>
import Vue from 'vue'
export default {
    data(){
        return {
            period:'month',
            DialogAddOrEditDay:false,
            DayDefineID: 1,
            toDate: '',
            txtMessage:'',
            events:[ ]
        }
    },
    computed:{
        ReadCalendar_InsertAndUpdate(){
            return this.$store.state.Calendar_InsertAndUpdate;
        },
        ReadCalendar_GetByDate(){
            return this.$store.state.Calendar_GetByDate.RequestResponse;
        },
    },
    watch:{
        ReadCalendar_InsertAndUpdate(res){
            if(res.Status!==undefined){
                if(res.Status){
                    if(res.RequestResponse[0].Message==='Successfully!'){
                        this.DialogAddOrEditDay=false;
                        this.Calendar_GetByDate();
                        this.$store.commit('ShowToast',{type:'success',message:'عملیات با موفقیت انجام شد.'})
                    }
                    
                }
                
            }
            this.events=[];
        },
        ReadCalendar_GetByDate(data){
            
            for(var i=0;i<data.length;i++){
                var item=data[i];
                console.log('ReadCalendar_GetByDate')
                console.log(item.TS.substring(0,10))
                var event= {id:i+1, startDateTime:this.$moment(item.TS.substring(0,10), 'YYYY-MM-DD'), endDateTime:this.$moment(item.TS.substring(0,10), 'YYYY-MM-DD'), title:item.Name, color:'#FF0000', classes: []}
                this.events.push(event);
            }
        }
    },
    mounted(){
        //this.addEvent();
        this.DayDefine_GetAll();
        this.Calendar_GetByDate();
    },
    methods:{
        DialogAddOrEditDayShow(){
            this.DialogAddOrEditDay=true;
        },
        DayDefine_GetAll(){
            this.$store.commit('DayDefine_GetAll');
        },
        Calendar_GetByDate(){
            var fromNow=Vue.moment().format('jYYYY-jMM-01');
            var toNow=Vue.moment().add(1,'month').format('jYYYY-jMM-01');
            console.log(fromNow)
            console.log(toNow)
             var from=Vue.moment(fromNow, "jYYYY-jMM-jDD").format("YYYY_MM_DD_00_00_00");
             var to=Vue.moment(toNow, "jYYYY-jMM-jDD").format("YYYY_MM_DD_23_59_59");
             console.log(from)
            console.log(to)
            this.$store.commit('Calendar_GetByDate',{
                UserID:1,
                TS1:from,
                TS2:to,
            });
        },
        Calendar_InsertAndUpdate(){
            var Date=Vue.moment(this.toDate, "jYYYY/jMM/jDD").format("YYYY-MM-DD");
            this.$store.commit('Calendar_InsertAndUpdate',{
                DayDefineID:this.DayDefineID,
                TS:Date,
                Message:this.txtMessage,
                UserID:1
            });
            
        },
        addEvent (day) {
            this.id += 1
            // console.log(day.format())
            this.events.push({
                id: this.id,
                title: 'test',
                startDateTime: this.$moment(day),
                endDateTime: this.$moment(day)
            })
        
        },
        GetOtionsDay(items){
                var options=[];
                var all={value:0,label:'-- انتخاب کنید --',disabled:true};
                options.push(all);
                for(var i=0;i<items.length;i++){
                    var item=items[i];
                    var option={value:item.DayDefineID,label:item.Name};
                    options.push(option);
                }
                return options;
        },
    }
}
</script>
<style>
    .card-body * {
            font: 17px BYekan, Tahoma;
    }
    .vpc_control-btn{
        display: flex;
    }

</style>